import {
  jsonParse,
  jsonStringify,
} from '@/shared/lib/core/json';
import {
  localStorageGet,
  localStorageSet,
} from '@/shared/lib/core/storage';
import { MAX_HIDDEN_TRIES } from '@/shared/lib/events/eventsConstants';
import emitter from '@/shared/services/emitter';
import { defineStore } from 'pinia';

const EVENTS_GENERATION_DELAY = 30000;
const EVENTS_KEY = 'events';
const GENERATOR_STATES_KEY = 'generators-states';
const localStorageSetEvents = localStorageSet.bind(null, EVENTS_KEY);
const localStorageSetGenStates = localStorageSet.bind(null, GENERATOR_STATES_KEY);

export interface IEvent {
  type: number,
  title: string,
  body: string
}
export interface IGeneratorState {
  generator: string,
  state: any
}

export const useEventsStore = defineStore('events', {
  state: () => ({
    events: [] as IEvent[],
    generatorsStates: {} as Record<string, any>,
    runDelay: EVENTS_GENERATION_DELAY,
    maxHiddenTries: MAX_HIDDEN_TRIES,
    hiddenTries: 0,
  }),
  actions: {
    fetchEvents() {
      localStorageGet(EVENTS_KEY).success((v: string) => {
        jsonParse(v).success((events: IEvent[]) => {
          if (events) {
            this.events = events;
          }
        });
      });
      localStorageGet(GENERATOR_STATES_KEY).success((v: string) => {
        jsonParse(v).success((generatorsStates: IGeneratorState[]) => {
          if (generatorsStates) {
            this.generatorsStates = generatorsStates;
          }
        });
      });
    },
    addEvent(payload: IEvent) {
      this.events.push(payload);
      jsonStringify(this.events).success(localStorageSetEvents);
      emitter.emit('createToast', {
        message: payload.title + ', ' + payload.body,
        color: 'success',
      });
    },
    addGeneratorState(payload: IGeneratorState) {
      this.generatorsStates[payload.generator] = payload.state;
      jsonStringify(this.generatorsStates).success(localStorageSetGenStates);
    },
    resetHiddenTries() {
      this.hiddenTries = 0;
    },
    incrementHiddenTries() {
      this.hiddenTries += 1;
    },
    generatorState(generator: string) {
      return this.generatorsStates[generator];
    },
  },
});
